export const WELCOME_RESOURCE_NAME = 'welcome';
